<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="editForm" :rules="rules" ref="editForm">
          <div>
            <el-row>


              <el-col :span="12" class="item">
                <el-form-item label="手机号" required prop="phone">
                  <el-input v-model="editForm.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="坐席客服名称" required prop="name">
                  <el-input v-model="editForm.name" placeholder="输入坐席客服名称"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item">
                <el-form-item label="400电话" required prop="callingPhone">
                  <el-input v-model="editForm.callingPhone" placeholder="输入400电话"></el-input>
                </el-form-item>
              </el-col>

            </el-row>


          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('editForm')">提交</el-button>
      </div>
    </div>


  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        name:'',
        callingPhone:'',
        phone:'',

        seatsCode:'',
      },


      rules:{
        phone:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '请输入正确的手机号'
          },
        ],
        name:[
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        callingPhone:[
          { required: true, message: '请输入400电话', trigger: 'blur' },
        ],

      },


    }
  },
  components: {

  },
  methods: {
    init(row){
      this.$refs.editForm.resetFields();

      this.editForm.name=row.userDTO.name;
      this.editForm.callingPhone=row.callingPhone;
      this.editForm.phone=row.userDTO.phone;

      this.editForm.seatsCode = row.seatsCode;

    },
    closeSelf() {
      this.$emit("closeEdit");
    },

    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          return false;
        }
      })
    },
    addSubmit(){


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }


      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Seats/EditByGov",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'warning', message: response.data.message});
            }
          }
      )
    },

    changeStatus:function (selVal) {
      this.editForm.status = selVal;
    },


  }
}
</script>

